import React from "react";
import { useHistory } from "react-router-dom";

import { useTheme } from "@mui/material";

import { useOperatorSlug } from "globals/hooks/useOperatorSlug";
import MoovsBanner from "components/globals/MoovsBanner";

type ContractBannerProps = {
  contractId: string;
};

function ContractBanner(props: ContractBannerProps) {
  const { contractId } = props;
  const history = useHistory();
  const operatorSlug = useOperatorSlug();
  const theme = useTheme();

  return (
    <MoovsBanner
      bannerBgColor={`${theme.palette.primary.main}1A`}
      bannerTextColor={theme.palette.primary.main}
      bannerText="This quote is part of a contract. Review all options before booking."
      actionButtonText="View Contract"
      onActionButtonClick={() =>
        history.push("/" + operatorSlug + "/contract/" + contractId)
      }
    />
  );
}

export default ContractBanner;
